import type { HTMLAttributes } from 'react';

export type LogoColor = 'light' | 'dark' | 'yellow';

export type LogoType = 'tipaw' | 'tipaw-pro';

export interface LogoProps extends HTMLAttributes<HTMLImageElement> {
  color: LogoColor;
  type: LogoType;
}
